import BaseEntity from '@/entities/BaseEntity';

export default class FacebookTargetingGeolocationCustomLocation extends BaseEntity {
  latitude = null;
  longitude = null;
  radius = 20;
  distance_unit = 'kilometer';
  name = null;
  country_code = null;

  constructor(rawData) {
    super();

    if (rawData && 'type' in rawData) {
      delete rawData.type;
    }

    this.updateWith(rawData);
  }

  get type() {
    return 'custom_location';
  }

  // Stable identifier for the template :key, remove() and the map circle/marker
  // key. It is a getter, so it is NOT serialized by toObject() — Meta does not
  // expect a key on custom_locations.
  get key() {
    return `${this.latitude},${this.longitude}`;
  }

  // The component's map- and name-logic reads item.meta.{latitude,longitude,
  // name,country_code}. Exposing it as a getter keeps it out of toObject() while
  // letting the existing city/place-oriented code work unchanged on this row.
  get meta() {
    return {
      latitude: this.latitude,
      longitude: this.longitude,
      name: this.name,
      country_code: this.country_code,
    };
  }

  get radiusMin() {
    return 1;
  }

  get radiusMax() {
    return 80;
  }
}
